/** Default occasion & jewelry type chips on /custom-jewelry (overridable in Site → Shop & trust). */

export const BESPOKE_OCCASION_DEFAULTS = [
  { value: 'haldi', label: 'Haldi' },
  { value: 'mehendi', label: 'Mehendi / Mehndi' },
  { value: 'sangeet', label: 'Sangeet' },
  { value: 'wedding', label: 'Wedding / Reception' },
  { value: 'festive', label: 'Festive / Other celebration' },
  { value: 'other', label: 'Other' },
];

export const BESPOKE_JEWELRY_TYPE_DEFAULTS = [
  { value: 'necklace', label: 'Necklace / Haar' },
  { value: 'earrings', label: 'Earrings / Jhumka' },
  { value: 'tikka', label: 'Maang tikka' },
  { value: 'bangles', label: 'Bangles / Kada' },
  { value: 'bracelet', label: 'Bracelet' },
  { value: 'other', label: 'Something else' },
];

/** Shown in admin for older requests only — not offered on the public form. */
export const BESPOKE_JEWELRY_TYPE_LEGACY = [{ value: 'full-set', label: 'Full set (multiple pieces)' }];
